import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import {ImageBackground, Text, TouchableOpacity, View} from 'react-native';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import Project from "../../../../../Common/DTO/Project";
import {styles} from "./InvestCtaViewStyle";
import {translate} from "../../../../../Common/Utils/translation.utils";
import {getToken} from "../../../../../Common/Utils/token.utils";
import {Application, LanguageManager, Managers, NavigationManager} from "@levelapp/softfabric";
import {useWindowSizeContext} from "../../../../../Common/contexts/WindowSizeContext";

interface InvestCtaViewProps {
  project: Project;
}

export const InvestCtaView = ({project}: InvestCtaViewProps) =>  {
  const {width, height, isMobile} = useWindowSizeContext();
  const padding = height * 0.15;
  const marginTop = 92;
  const buttonStyle = {
    cursor: 'pointer',
    marginTop: height*0.025,
    width: isMobile ? width*0.65 : width*0.35
  };
  const fontSize = isMobile ? 18 : 24;
  const languageManager: LanguageManager = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);

  function navigateToInvest() {
    const code = project?.code;
    const token = getToken();
    if (token)
      Application.current?.resolve<NavigationManager>(Managers.NAVIGATION_MANAGER)?.navigate(`/invest/${code}`);
    else
      window.location.href = `https://my.beebonds.com/${languageManager.language}/login?redirect=https://invest.beebonds.com/${languageManager.language}/invest/${code}`;
  }

  function navigateToContact() {
    window.location.href = "https://www.beebonds.com/contact/";
  }
    return (
        <ImageBackground
            source={{uri: 'https://beebondsstorage.blob.core.windows.net/files/web/investBackground.png'}}
            style={[styles.page, {marginTop: marginTop, paddingVertical: padding}]}
        >
          <View style={[styles.investCtaContainer]}>
            <Text style={[styles.title, {width: width*0.6, fontSize: fontSize*1.3}]}> 
              {project.code === 'rwdm'
                ? `${translate("ParticipateCTAText")} ${project.projectName}`
                : `${translate("InvestCTAText")} ${project.projectName}`}
            </Text>
            <Text style={[styles.subTitle, {width: width*0.6, fontSize: fontSize}]}>{Helpers.getCorrectTranslation(project.projectIntroduction)}</Text>
            <View style={isMobile ? styles.col : styles.row}>
              <div style={buttonStyle}>
                <TouchableOpacity onPress={navigateToInvest}>
                  <View style={styles.investButton}>
                    <TranslationView style={[styles.investText, {fontSize: fontSize}]}>{project.code === 'rwdm' ? 'participate' : 'invest'}</TranslationView>
                  </View>
                </TouchableOpacity>

              </div>
              <div style={buttonStyle}>
                <TouchableOpacity onPress={navigateToContact}>
                  <View style={[styles.contactButton, isMobile ? {} : {marginLeft: 20} ]}>
                    <TranslationView style={[styles.contactText, {fontSize: fontSize}]}>Contact</TranslationView>
                  </View>
                </TouchableOpacity>
              </div>
            </View>
          </View>
        </ImageBackground>
    );
}
export default InvestCtaView;